var $0c79cbd512713d63$exports = {};
$0c79cbd512713d63$exports = {
    "longPressMessage": `Men\xfc\xfc avamiseks vajutage pikalt v\xf5i vajutage klahve Alt + allanool`
};


export {$0c79cbd512713d63$exports as default};
//# sourceMappingURL=et-EE.mjs.map
